// Import necessary modules
import { React, useEffect, useState } from 'react';
import { Grommet, Card, CardHeader, Anchor, CardBody, CardFooter, Box, Text, Button, Image, Tab, Tabs } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import ReleaseSummary from '../custom-page/ReadMoreReadLess.js';
import { Bold } from 'grommet-icons';
import PropTypes from 'prop-types';


const QuickLinksComponent = ({ QuickLinks }) => {
    console.log('quicklinks', QuickLinks);

    return (
        <Grommet themeMode="light" theme={hpe}>
         
            {QuickLinks && QuickLinks.length > 0 ? (
                <Box align="start" gap="medium" pad="medium">
                    {QuickLinks.map((link, index) => (
                        <Box key={index} gap="small">
                            <Anchor
                                href={link.Link}
                                label={link.LinkName}
                                target="_blank"
                                rel="noopener noreferrer"
                            />
                        </Box>
                    ))}
                </Box>
            ) : (
                <Text font-size="medium">No Quick Links available</Text>
            )}
        </Grommet>
    );
};

QuickLinksComponent.propTypes = {
    QuickLinks: PropTypes.arrayOf(
        PropTypes.shape({
            LinkName: PropTypes.string.isRequired,
            Link: PropTypes.string.isRequired
        })
    ).isRequired
};

export default QuickLinksComponent;
